<template>
  <section>
    <div class="card float-left ml-3 card-chat-booking">
      <div class="card-body">
        
        <div class="d-flex justify-content-start align-items-center">
          <div class="flex-fill">
            <h4>{{ $t('message.service_item.select') }}</h4>
          </div>
          <div v-if="serviceItems && !isConfirmed">
            <a href="" class="text-info" @click.prevent="clearSelectedServiceItems()">
              {{ $t('message.service_item.clear') }}
            </a>
          </div>
        </div>

        <div class="card pointer-item mb-1 border-divider" @click="openServiceItemModal()">
          <div class="card-body">
            <div class="d-flex justify-content-start align-items-center" v-if="!serviceItems">
              <div v-if="parentService"><img :src="parentService.icon_url" width="24"/></div>
              <div class="flex-fill px-3">{{ $t('message.service_item.select') }}</div>
              <div><i class="fal fa-plus-circle text-info fa-lg"></i></div>
            </div>
            <div class="d-flex justify-content-start align-items-top" v-else>
              <div v-if="parentService">
                <img :src="parentService.icon_url" width="32" class="active-svg-icon"/>
              </div>
              <div class="flex-fill px-3">
                <div class="mb-2"><strong>{{ $t('message.service_item.selected_list') }}</strong></div>
                <div v-for="serviceItem in serviceItems">
                  {{ serviceItem | multiLangName }}: {{ serviceItem.count }} {{ serviceItem.item_unit | multiLangName }}
                </div>
                <div class="text-info text-small mt-2">{{ $t('message.service_item.remark') }}</div>
              </div>
              <div v-if="!isConfirmed">
                <button class="btn btn-outline-info rounded-pill">{{ $t('message.button.edit') }}</button>
              </div>
            </div>
          </div>
        </div>
        
        <section class="pt-3" v-if="serviceItems">
          <div class="d-flex justify-content-start align-items-center">
            <div class="flex-fill">
              {{ $t('message.booking.new_booking.subtotal') }}
            </div>
            <div class="text-info">
              {{ subtotal | currency }}
            </div>
          </div>
          <div class="mt-2">
            <button class="btn btn-info btn-block" 
                    @click="confirmServiceItems" 
                    v-if="!isConfirmed">{{ $t('message.button.submit') }}</button>
            <div class="text-center mt-3" v-else>
              <i class="fal fa-check-circle text-success"></i> {{ $t('message.service_item.confirmed') }}
            </div>
          </div>
        </section>
        
      </div>
    </div>
    <!-- Service items modal -->
    <service-item-modal ref="serviceItemModal"
                        v-if="parentService && parentService.has_service_items"
                        :parentService="parentService" 
                        @selectServiceItems="setServiceItems"/>
  </section>
  
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import serviceHelpers from '../../../helpers/serviceHelpers'
  import ServiceItemModal from '../../booking/components/ServiceItemModal'

  export default {
    props: {
      message: Object
    },
    components: {
      ServiceItemModal
    },
    data () {
      return {
        parentService: null,
        serviceItems: null,
        subtotal: 0.0,
        isConfirmed: false
      }
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState'
      }),
      ...mapState('chatBooking', ['messages', 'bookingData'])
    },
    methods: {
      openServiceItemModal () {
        if (!this.isConfirmed) {
          this.$refs.serviceItemModal.showModal(true, Number(this.bookingData.province_id))
        }
      },
      calculateCost () {
        this.subtotal = serviceHelpers.getTotalPriceOfServiceItems(this.serviceItems)
      },
      setServiceItems (serviceItems) {
        if (serviceItems) {
          this.serviceItems = []
        }
        this.serviceItems = serviceItems
        this.calculateCost()
      },
      clearSelectedServiceItems () {
        this.serviceItems = null
        this.subtotal = 0.0
        this.$refs.serviceItemModal.clearData()
      },
      confirmServiceItems () {
        let selectedServiceItems = ''
        this.serviceItems.forEach(item => {
          selectedServiceItems += `${item.name_th}: ${item.count} ${item.item_unit.name_th}<br>`
        })
        const message = {
          sender_type: 'user',
          type: 'text',
          label: 'selected-work-hour',
          text: selectedServiceItems,
          data: this.serviceItems
        }
        this.$store.commit('chatBooking/ADD_MESSAGE', message)
        this.isConfirmed = true
      }
    },
    mounted () {
      if (this.bookingData) {
        const serviceId = Number(this.bookingData.service_id)
        this.parentService = this.globalState.services[serviceId]
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/chatBooking/components/ServiceItemMessage.vue